import React from "react";
import PropTypes from "prop-types";
import {QuickAddItemType} from "../../../../../../app/quick-add/@types";

export default class CRMContactPopoverMenuMore extends React.Component<any> {

    static propTypes = {
        parent: PropTypes.object,
        field: PropTypes.object
    }

    render() {
        return (
            <div className="help">
                <div className="ui5-link-small" onClick={()=>{
                    this.props.parent.hidePopover();
                    gd.openNew(QuickAddItemType.CRM, {type: 'contact'});
                }}>New Contact</div>
            </div>
        );
    }
}